import { PICTREE } from "../../constants";

const initialState = {
  loading: false,
  selectedSeasonId: "cmunxinty000079zc6zf595vs",
  selectedSeasonIds: ["cmunxinty000079zc6zf595vs"],
  selectedBoostEventId: "__ALL__",
  selectedDateRange: [null, null],
  selectedCompanyCode: "NTT_ME",
  seasonOptions: [
    { value: "cmunxinty000079zc6zf595vs", label: "レギュラーシーズン3" },
  ],
  companyOptions: [
    { value: "NTT_ME", label: "NTT ME", active: true },
    { value: "TEPCO", label: "東京電力 TEPCO", active: false },
    { value: "NTT_FT", label: "NTT FT", active: false },
  ],
  kpis: [],
  trend: {
    date: [],
    uniqueShots: [],
    reviewerOk: [],
    uniqueShooters: [],
  },
  trendLoading: false,
  trendRows: [],
  trendRowsLoading: false,
  seasonChartLoading: false,
  seasonChart: {
    labels: [],
    series: [],
  },
  bootstrapEventLoading: false,
  bootstrapEventReady: false,
  eventRowsLoading: false,
  eventRows: [],
  areaSummary: null,
  areaTable: [],
  areaLoading: false,
  areaError: null,
  areaRequestKey: null,
};

export default function pictreeRegularSeasonEventReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_REGULAR_SEASON_EVENT_PAGE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case PICTREE.SET_REGULAR_SEASON_EVENT_PAGE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case PICTREE.SET_REGULAR_SEASON_EVENT_AREA_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
